module.exports = __webpack_public_path__ + "static/media/mplayer_1_11.b1a115e7.ico";